import { ChangeEvent } from 'react';

import * as S from './style';

interface Props {
  id: string;
  label?: string;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  disabled?: boolean;
}

export default function SwitchButton({ id, onChange, label, disabled, checked }: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <S.Wrapper>
      {label && <S.Text>{label}</S.Text>}
      <S.ButtonWrapper>
        <S.Input
          type='checkbox'
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <S.Label checked={checked} htmlFor={id}>
          &nbsp;
        </S.Label>
      </S.ButtonWrapper>
    </S.Wrapper>
  );
}
